import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Created by ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { href: "https://github.com/JanMalch" }, "JanMalch", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" · ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/JanMalch/doomsday",
  rel: "noopener"
}, "Source Code", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Welcome = _resolveComponent("Welcome")!
  const _component_Method = _resolveComponent("Method")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Welcome),
    _createVNode(_component_Method),
    _hoisted_1,
    _createElementVNode("small", null, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createTextVNode(" · © JanMalch, " + _toDisplayString(_ctx.currentYear), 1)
    ])
  ], 64))
}